<div class="container container-input" style="width:100%; height: 35px;" fxLayout="row" fxLayout.xs="column"
    fxLayoutGap="0.5%">
    <div fxFlex="50%">
        <h2 style="font-weight:bold">Olá {{currentUser.firstName}},</h2>
    </div>
</div>
<p style="margin-top: 0px;padding-bottom: 20px;">{{currentDate}}</p>

<app-ultimos-protocolos></app-ultimos-protocolos>